module.exports = __webpack_public_path__ + "static/img/home_product_00_zh-3.f1926e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home_product_00_zh-3.png
// module id = 4V7G
// module chunks = 34